import { gettext } from '@eventbrite/i18n';

const TITLE_PAYOUTS_FROZEN = gettext('Your payouts are frozen');
const ADD_TAXPAYER_INFORMATION = gettext('Add Taxpayer information');

export const TAXPAYER_SUMMARY_STATUS: { [index: string]: any } = {
    none: {
        type: 'none',
        modalNotification: false,
        tooltipNotification: false,
        message: {
            title: '',
            subTitle: '',
            titleTooltip: '',
            subTitleTooltip: '',
            buttonText: '',
            buttonLink: '',
        },
    },
    fulfilled: {
        type: 'fulfilled',
        blockNew: false,
        blockEdit: false,
        tooltipNotification: false,
        modalNotification: false,
    },
    wanted: {
        type: 'wanted',
        modalNotification: true,
        tooltipNotification: false,
        message: {
            title: gettext('Make sure you get paid'),
            subTitle: gettext(
                'When your sales reach $600, the IRS requires us to provide your taxpayer information in order to process your payouts.',
            ),
            titleTooltip: '',
            subTitleTooltip: '',
            buttonText: ADD_TAXPAYER_INFORMATION,
            buttonLink: '/organizations/taxpayer-information',
        },
    },
    needed: {
        type: 'needed',
        modalNotification: true,
        tooltipNotification: true,
        message: {
            title: TITLE_PAYOUTS_FROZEN,
            subTitle: gettext(
                'Since your sales reached $600, the IRS requires us to provide your taxpayer information. Add your taxpayer information in order to receive your payouts.',
            ),
            titleTooltip: TITLE_PAYOUTS_FROZEN,
            subTitleTooltip: gettext(
                'Add your taxpayer information in order to receive your payouts.',
            ),
            buttonText: ADD_TAXPAYER_INFORMATION,
            buttonLink: '/organizations/taxpayer-information',
        },
    },
    mismatched: {
        type: 'mismatched',
        modalNotification: true,
        tooltipNotification: true,
        message: {
            title: TITLE_PAYOUTS_FROZEN,
            subTitle: {
                __html: gettext(
                    "According to the IRS, your taxpayer information doesn't match their records. Please update your:<br><ul><li>Name</li><li>identification number</li></ul>You won't receive a payout until your information is updated.",
                ),
            },
            titleTooltip: TITLE_PAYOUTS_FROZEN,
            subTitleTooltip: gettext(
                "Your tax information doesn't match IRS records. Update your information to receive your payouts.",
            ),
            buttonText: gettext('Update Taxpayer information'),
            buttonLink: '/organizations/taxpayer-information',
        },
    },
    locked: {
        type: 'locked',
        modalNotification: true,
        tooltipNotification: true,
        message: {
            title: gettext('Contact payment ops to receive your payouts'),
            subTitle: gettext(
                "According to the IRS, your taxpayer information doesn't match their records for the second time in 3 years. You won't receive a payout until your information is updated correctly. Contact paymentsteam@eventbrite.com to update your information.",
            ),
            titleTooltip: TITLE_PAYOUTS_FROZEN,
            subTitleTooltip: gettext(
                "Your tax information doesn't match IRS records. Contact paymentsteam@eventbrite.com to update your information and resume your payouts.",
            ),
            buttonText: gettext('Contact us'),
            buttonLink: 'mailto:paymentsteam@eventbrite.com',
        },
    },
};
